<template>
  <div>
    <div v-if="!loading">
      <NumberFormGroup
          :value="value.limit"
          name="limit"
          label="Limit"
          :error="(errors.limit || [])[0]"
          help-text="The number of items to display."
          @input="emit('limit', $event)"
      />

      <SelectFormGroup
          :value="value.sort_by"
          name="sort_by"
          label="Sort By"
          :error="(errors.sort_by || [])[0]"
          :options="[{value: 'title', label:' Title'}, {value: 'random', label:'Random'}]"
          help-text="The field to sort registrations by."
          @input="emit('sort_by', $event)"
      />

      <RadioFormGroup
          :value="value.context"
          name="context"
          label="Context"
          :error="(errors.context || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('context', $event)"
      />

      <TextFormGroup
          :value="value.link_url"
          name="link_url"
          label="Link URL"
          :error="(errors.link_url || [])[0]"
          @input="emit('link_url', $event)"
      />

      <TextFormGroup
          :value="value.link_text"
          name="link_text"
          label="Link Text"
          :error="(errors.link_text || [])[0]"
          @input="emit('link_text', $event)"
      />

      <SelectFormGroup
          :value="value.content_registration_category_id"
          name="content_registration_category_id"
          label="Content Registration Category"
          :error="(errors.content_registration_category_id || [])[0]"
          :options="contentRegistrationCategoryOptions"
          :nullable="true"
          help-text="A category to filter registrations by."
          @input="emit('content_registration_category_id', $event)"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {NumberFormGroup, RadioFormGroup, SelectFormGroup,TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      contentRegistrationCategories: null,

      shared: store,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    contentRegistrationCategoryOptions() {
      return this.contentRegistrationCategories.map(contentRegistrationCategory => {
        return {
          value: contentRegistrationCategory.id,
          label: contentRegistrationCategory.attributes.name
        }
      })
    }
  },

  methods: {
    load() {
      http.get('/api/v2/content-registration-categories', {'filter[portal_id]': this.portal.id}).then(response => {
        this.contentRegistrationCategories = response.data.data

        this.loading = false
      })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
